/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { useCallback } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { spacing } from '../../shared/theme/spacing';
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors';
import { CONTENT_MAX_WIDTH_AUTH } from '../../shared/layout/breakpoints';
import { logout } from '../../auth/application/authSession';

/**
 * Pantalla para empleados revocados (is_active=false).
 * Acción: cerrar sesión.
 */
export const NoBusinessAccessScreen = () => {
  const handleLogout = useCallback(async () => {
    await logout();
  }, []);

  return (
    <View style={styles.root}>
      <ScrollView contentContainerStyle={styles.scrollContent} alwaysBounceVertical={false}>
        <View style={styles.card}>
          <View style={styles.iconWrap}>
            <Ionicons name="lock-closed-outline" size={48} color={ticketColors.ink3} />
          </View>
          <Text style={styles.title}>Sin acceso al negocio</Text>
          <Text style={styles.subtitle}>
            Tu acceso al negocio fue revocado. Ya no podés entrar al POS ni gestionar pedidos.
            Si querés, podés seguir comprando en el portal de Vuelto con el mismo login.
          </Text>

          <View style={styles.actions}>
            <TouchableOpacity
              style={styles.btnSecondary}
              onPress={() => void handleLogout()}
              accessibilityRole="button"
              accessibilityLabel="Cerrar sesión"
            >
              <Text style={styles.btnSecondaryText}>Cerrar sesión</Text>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: ticketColors.bg,
    alignItems: 'center',
    justifyContent: 'center',
  },
  scrollContent: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.lg,
  },
  card: {
    width: '100%',
    maxWidth: CONTENT_MAX_WIDTH_AUTH,
    backgroundColor: ticketColors.paper,
    borderRadius: 16,
    padding: spacing.xl,
    alignItems: 'center',
    gap: spacing.md,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.ruleSoft,
  },
  iconWrap: {
    marginBottom: spacing.xs,
  },
  title: {
    fontSize: 22,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 15,
    lineHeight: 22,
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
    textAlign: 'center',
  },
  actions: {
    width: '100%',
    gap: spacing.sm,
    marginTop: spacing.md,
  },
  btnSecondary: {
    paddingVertical: spacing.md,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  btnSecondaryText: {
    color: ticketColors.ink2,
    fontWeight: '600',
    fontSize: 15,
    fontFamily: ticketFonts.sans,
  },
});
